import { useActiveShopTab } from './useActiveShopTab';
import { useIsViewingOwnShop } from './useIsViewingOwnShop';

import { ShopProfileSection } from '@/modules/activityTracker/constants';
import { useRepopProducts } from '@/modules/receipts/hooks/useRepopProducts';
import { MAX_REPOP_RECEIPTS } from '@/modules/shop/constants';

export const repopSupportedTabs = [
  ShopProfileSection.Shop,
  ShopProfileSection.Selling,
  ShopProfileSection.Sold,
];

export function useRepopOnEmptyShop() {
  const { tab } = useActiveShopTab();
  const isViewingOwnShop = useIsViewingOwnShop();

  const isRepopSupportedTab = repopSupportedTabs.includes(tab);
  const isRepopModuleVisible = isViewingOwnShop && isRepopSupportedTab;
  const { products } = useRepopProducts({
    enabled: isRepopModuleVisible,
    limit: MAX_REPOP_RECEIPTS,
  });
  return {
    products,
    showProducts: isRepopModuleVisible,
  };
}
